import { Injectable } from '@angular/core'
import { FacetService, ProductFacetService } from '@spartacus/storefront'
import { HttpUrlEncodingCodec } from '@angular/common/http'

@Injectable({
  providedIn: 'root'
})
export class MbFacetService extends FacetService {

  constructor (protected productFacetService: ProductFacetService) {
    super(productFacetService)
  }

  getLinkParams (query: string): { [key: string]: string } {
    return {
      // to avoid encoding issues with facets that have space (' ') in their name,
      // we replace the decoded '+' back to empty space ' '.
      query: new HttpUrlEncodingCodec().decodeValue(query?.replace(/\+/g, ' ')),
    }
  }
}
